import {PullShoots} from '../components/pull-shoots'
import {GetIssueDate} from '../components/get-issue-date.tsx'
import TicketSubmit from '../components/ticket-submit.tsx'
import {CHATBOT_SOURCES, CHATBOT_ASSIGNMENTS_TASK_STATUSES} from '../types'
import {useChatbotStore} from '../store/chatbotStore'
import i18next from 'i18next'
export const mb22FlowSteps = (isInShootPage: boolean) => [
    {
        id: 'MB2.2',
        message: i18next.t('chatbot:mb22:starting'),
        trigger: () => {
            useChatbotStore.getState().addStepToHistory({
                id: 'MB2.2',
                source: CHATBOT_SOURCES.CHATBOT,
                text: 'Please select the shoot you want payment information for'
            })
            return 'MB2.2_pull'
        }
    },
    {
        id: 'MB2.2_pull',
        component: (
            <PullShoots
                flowSource="MB2.2_pull"
                statuses={[
                    CHATBOT_ASSIGNMENTS_TASK_STATUSES.ASSETS_IN_REVIEW,
                    CHATBOT_ASSIGNMENTS_TASK_STATUSES.COMPLETED
                ]}
                filterByDate="1" // 1 = get only shoots in the last month
            />
        ) // Trigger managed by the component
    },
    {
        id: 'MB2.2_issuedate',
        component: <GetIssueDate flowSource="MB2.2_issuedate" />,
        asMessage: true
    }, // Trigger managed by the component

    // ID not-found flow
    {
        id: 'MB2.2_notfound',
        message: i18next.t('chatbot:mb22:mb2.2_notfound'),
        trigger: () => {
            useChatbotStore.getState().addStepToHistory({
                id: 'MB2.2_notfound',
                source: CHATBOT_SOURCES.CHATBOT,
                text: 'For which airbnb ID you want to have information?'
            })
            return 'MB2.2_notfound_input'
        }
    },
    {
        id: 'MB2.2_notfound_input',
        user: true,
        validator: (value: string) => {
            if (isNaN(Number(value))) {
                return i18next.t('chatbot:commons:enter_number')
            }
            return true
        },
        trigger: ({value}: {value: string}) => {
            useChatbotStore.getState().addStepToHistory({
                id: 'MB2.2_notfound_input',
                source: CHATBOT_SOURCES.USER,
                text: value
            })
            return 'MB2.2_ticket'
        }
    },
    {
        id: 'MB2.2_ticket',
        component: <TicketSubmit reason="payment_issue" isInShootPage={isInShootPage} />,
        asMessage: true,
        trigger: () => {
            useChatbotStore.getState().addStepToHistory({
                id: 'MB2.2_ticket',
                source: CHATBOT_SOURCES.CHATBOT,
                text: '[Ticket submitted]'
            })
            return 'send_log'
        }
    }
]
